export enum HubMethod {
    TOKEN_VERIFY = 'TokenVerify',
    REGISTRATION_WITH_CONFIRMATION = 'RegistrationWithConfirmation',
    REGISTRATION_WITH_EMAIL_ONLY = 'RegistrationWithEmailOnly',
    REGISTRATION_WITH_PASSWORD = 'RegistrationWithPassword',
    CHECK_EMAIL_AVAILABLE = 'CheckEmailAvailable',
    GET_POLICY = 'GetPolicy',
    GET_TOKEN_BY_CONTINUE_PLAYING_URL = 'GetTokenByContinuePlayingUrl',
    GET_GAME_START_DATA = 'GetGameStartData',
    REQUEST_EMAIL_OTP_REG = 'RequestEmailOtpRegister',
    EMAIL_OTP_REG = 'EmailOtpRegistration'
}
